import { render, staticRenderFns } from "./BranchListAddNew.vue?vue&type=template&id=0d07b0e5&"
import script from "./BranchListAddNew.vue?vue&type=script&lang=js&"
export * from "./BranchListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./BranchListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports